/**
 * Product Card Initializer
 * Este script proporciona una función para inicializar los product-cards
 * que se cargan dinámicamente en el DOM (búsqueda predictiva, infinite scroll, etc.)
 */

function initializeProductCards(container = document) {
  console.log('Inicializando product-cards dinámicos');
  
  // Buscar todos los contenedores de productos en el contenedor especificado
  const productWrappers = container.querySelectorAll('.card-wrapper');
  
  if (productWrappers.length === 0) {
    console.log('No se encontraron product-cards para inicializar');
    return;
  }
  
  console.log(`Inicializando ${productWrappers.length} product-cards`);
  
  productWrappers.forEach(wrapper => {
    // Obtener el ID del producto y el ID de la variante seleccionada
    const productId = wrapper.getAttribute('data-product');
    const selectedVariantId = wrapper.getAttribute('data-selected-variant-id');
    const productHandle = wrapper.getAttribute('data-product-handle');
    
    if (!productId) return;
    
    // Obtener todos los botones de variante en este wrapper
    const variantButtons = wrapper.querySelectorAll('.variant-button');
    
    // Agregar event listeners a los botones de variante
    variantButtons.forEach(button => {
      // Verificar si ya tiene un event listener para evitar duplicados
      if (!button.hasAttribute('data-initialized')) {
        button.addEventListener('click', selectVariant);
        button.setAttribute('data-initialized', 'true');
      }
    });
    
    // Inicializar el botón de agregar al carrito si existe
    const addToCartButton = wrapper.querySelector('.add-to-cart-button');
    if (addToCartButton && !addToCartButton.hasAttribute('data-initialized')) {
      addToCartButton.addEventListener('click', function() {
        const variantId = wrapper.getAttribute('data-selected-variant-id');
        const productHandle = wrapper.getAttribute('data-product-handle');
        const selectedButton = wrapper.querySelector(`.variant-button.selected`);
        const variantTitle = selectedButton ? selectedButton.getAttribute('data-variant-title') : '';
        const variantPrice = selectedButton ? selectedButton.getAttribute('data-variant-price') : '';
        
        handleAddToCartOrRequest(variantId, variantPrice, productHandle, variantTitle);
      });
      addToCartButton.setAttribute('data-initialized', 'true');
    }
  });
  
  // Intentar seleccionar automáticamente la variante de 6 sesiones si está disponible
  setTimeout(() => {
    autoSelectSixSessions(container);
  }, 200); // Delay leve para asegurar que el DOM esté listo
}

// Función para seleccionar una variante
function selectVariant(event) {
  const button = event.currentTarget;
  const cardWrapper = button.closest('.card-wrapper');
  const variantId = button.getAttribute('data-variant-id');
  const variantPrice = button.getAttribute('data-variant-price');
  const variantCompareAtPrice = button.getAttribute('data-variant-compare-at-price');
  const variantDiscount = button.getAttribute('data-variant-discount');
  const variantTitle = button.innerText.trim();
  const productId = cardWrapper.getAttribute('data-product');
  
  // Actualizar el estado seleccionado de los botones
  const allButtons = cardWrapper.querySelectorAll('.variant-button');
  allButtons.forEach(btn => btn.classList.remove('selected'));
  button.classList.add('selected');
  
  // Actualizar el ID de variante seleccionada en el wrapper
  cardWrapper.setAttribute('data-selected-variant-id', variantId);
  
  // Actualizar el precio mostrado
  const priceElement = cardWrapper.querySelector(`#variant-price-${productId} .current-price`);
  if (priceElement) {
    priceElement.textContent = variantPrice;
  }
  
  // Actualizar el precio de comparación si existe
  const compareAtPriceElement = cardWrapper.querySelector(`#variant-price-${productId} .compare-price`);
  if (compareAtPriceElement) {
    if (variantCompareAtPrice && variantCompareAtPrice !== 'null' && variantCompareAtPrice !== '0') {
      compareAtPriceElement.textContent = variantCompareAtPrice;
      compareAtPriceElement.style.display = 'inline-block';
    } else {
      compareAtPriceElement.style.display = 'none';
    }
  }
  
  // Actualizar el badge de descuento si existe
  const badgeElement = cardWrapper.querySelector(`#badge-${productId} .badge`);
  if (badgeElement && variantDiscount && variantDiscount !== '0') {
    badgeElement.textContent = `-${variantDiscount}% OFF`;
    badgeElement.style.display = 'inline-block';
  } else if (badgeElement) {
    badgeElement.style.display = 'none';
  }
  
  // Actualizar la URL del enlace
  const imageLink = cardWrapper.querySelector('.card__inner a');
  const titleLink = cardWrapper.querySelector('.card__title a');
  const productHandle = cardWrapper.getAttribute('data-product-handle');
  const newUrl = `https://belenus.cl/products/${productHandle}?variant=${variantId}`;
  
  if (imageLink) {
    imageLink.setAttribute('href', newUrl);
  }
  if (titleLink) {
    titleLink.setAttribute('href', newUrl);
  }
  
  // Actualizar el mensaje de cuotas
  updateInstallments(cardWrapper, variantPrice, variantTitle);
}

// Función para actualizar el mensaje de cuotas
function updateInstallments(cardWrapper, price, variantTitle) {
  const installmentElement = cardWrapper.querySelector('.installments-message');
  if (!installmentElement) return;
  
  const installmentPriceElement = installmentElement.querySelector('.installment-price');
  if (!installmentPriceElement) return;
  
  if (variantTitle.includes("1ª sesión cliente nuevo") || 
      variantTitle.includes("6 sesiones cliente nuevo") || 
      variantTitle.includes("3 sesiones cliente nuevo") || 
      variantTitle.includes("15 Créditos Belenus") || 
      variantTitle.includes("30 Créditos Belenus")) {
      installmentElement.classList.add('installments-hidden');
      installmentPriceElement.innerText = '';
  } else {
      installmentElement.classList.remove('installments-hidden');
  
      // Extraer solo los números del precio
      const priceNumber = parseInt(price.replace(/[^0-9]/g, ''), 10);
      const installmentAmount = Math.round(priceNumber / 6);
      
      // Formatear el monto en formato de moneda chilena
      const formattedInstallmentAmount = installmentAmount.toLocaleString('es-CL', {
          style: 'currency',
          currency: 'CLP'
      });
  
      installmentPriceElement.innerText = formattedInstallmentAmount;
  }
}

// Función para seleccionar automáticamente la variante de 6 sesiones
function autoSelectSixSessions(container = document) {
  console.log('Iniciando selección automática de 6 sesiones');
  
  // Buscar todos los contenedores de productos
  const productWrappers = container.querySelectorAll('.card-wrapper');
  
  productWrappers.forEach(wrapper => {
    // Verificar si ya tiene una variante seleccionada
    const selectedButton = wrapper.querySelector('.variant-button.selected');
    if (selectedButton) {
      // Ya hay una variante seleccionada, no hacer nada
      return;
    }
    
    // Obtener todos los botones de variante en este wrapper
    const variantButtons = wrapper.querySelectorAll('.variant-button');
    
    // Primero buscar botones que contengan "6 sesiones" en el título
    let sixSessionsButton = null;
    let bestVariantButton = null;
    let highestDiscount = -1;
    
    variantButtons.forEach(button => {
      const variantTitle = button.innerText.trim();
      const discount = parseInt(button.getAttribute('data-variant-discount') || '0', 10);
      
      // Priorizar variantes con "6 sesiones" en el título
      if (variantTitle.includes('6 sesiones')) {
        sixSessionsButton = button;
      }
      
      // Alternativamente, seleccionar la variante con mayor descuento
      if (discount > highestDiscount) {
        highestDiscount = discount;
        bestVariantButton = button;
      }
    });
    
    // Seleccionar la mejor opción: primero 6 sesiones, luego el de mayor descuento
    const buttonToSelect = sixSessionsButton || bestVariantButton;
    
    if (buttonToSelect) {
      // Simular un clic en el botón
      buttonToSelect.click();
    }
  });
}

// Función para manejar la adición al carrito o redirección
function handleAddToCartOrRequest(variantId, variantPrice, productHandle, variantTitle) {
  if (variantTitle.trim() === "1ª sesión cliente nuevo" || 
      variantTitle === "6 sesiones cliente nuevo" || 
      variantTitle === "3 sesiones cliente nuevo") {
    window.location.href = `https://belenus.cl/products/${productHandle}?variant=${variantId}`;
  } else {
    addToCart(variantId);
  }
}

// Exportar la función para que esté disponible globalmente
window.initializeProductCards = initializeProductCards;

// Inicializar los product-cards al cargar la página
document.addEventListener('DOMContentLoaded', function() {
  initializeProductCards();
});

// Observador de mutaciones para detectar cambios en el DOM
// Esto ayudará a inicializar product-cards que se agreguen dinámicamente
const observer = new MutationObserver(mutations => {
  mutations.forEach(mutation => {
    if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
      // Verificar si alguno de los nodos agregados contiene product-cards
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) { // ELEMENT_NODE
          // Verificar si el nodo es un product-card o contiene product-cards
          if (node.classList && node.classList.contains('card-wrapper')) {
            // Es un product-card, inicializarlo
            initializeProductCards(node.parentNode);
          } else if (node.querySelectorAll) {
            // Buscar product-cards dentro del nodo
            const productCards = node.querySelectorAll('.card-wrapper');
            if (productCards.length > 0) {
              initializeProductCards(node);
            }
          }
        }
      });
    }
  });
});

// Configurar el observador para que observe todo el documento
observer.observe(document.body, {
  childList: true,
  subtree: true
});

// Asegurarse de que el script se ejecute después de que el DOM esté completamente cargado
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initializeProductCards();
  });
} else {
  // El DOM ya está cargado
  initializeProductCards();
}
